/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/prefer-default-export */
/**
 *
 * @param {*} arr Array in which want to remove duplicates
 * @returns
 */

export const removeDuplicates = arr => {
  return arr.filter((item, index) => arr.indexOf(item) === index)
}
